import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/shared/lib/cn";
import { Card, CardContent, CardHeader } from "@/shared/ui/card";

interface SectionCardProps extends Omit<ComponentProps<typeof Card>, "title"> {
  title: ReactNode;
  description?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  contentClassName?: string;
}

export function SectionCard({
  title,
  description,
  meta,
  actions,
  children,
  className,
  contentClassName,
  ...props
}: SectionCardProps) {
  return (
    <Card className={cn("shadow-none", className)} {...props}>
      <CardHeader className="flex-row items-start justify-between gap-3 pb-2">
        <div className="min-w-0">
          <h3 className="m-0 font-mono text-sm font-bold tracking-[0.08em] text-warning uppercase">
            {title}
          </h3>
          {description ? (
            <p className="mt-1 mb-0 text-xs leading-snug text-foreground-muted">
              {description}
            </p>
          ) : null}
        </div>
        {actions || meta ? (
          <div className="flex shrink-0 items-center gap-2">
            {meta}
            {actions}
          </div>
        ) : null}
      </CardHeader>
      <CardContent className={cn("pt-1", contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
